import { type GetAllHoldoutsQueryParams, getAllHoldouts } from '@gonfalon/openapi/operations/getAllHoldouts';
import { type GetHoldoutQueryParams, getHoldout } from '@gonfalon/openapi/operations/getHoldout';
import { getHoldoutById } from '@gonfalon/openapi/operations/getHoldoutById';
import { createQueryKeys } from '@lukemorales/query-key-factory';

import { createQueryOptions } from '../internal/createQueryOptions';
import { reactQueryResponseAdapter } from '../internal/reactQueryResponseAdapter';

export const getAllHoldoutsQuery = createQueryOptions(getAllHoldouts);
export const getHoldoutQuery = createQueryOptions(getHoldout);

/**
 * @deprecated Use `createQueryOptions` with the OpenAPI operation directly instead.
 * See packages/rest-api/README.md for the recommended pattern.
 */
export const holdouts = createQueryKeys('holdouts', {
  list: ({
    projectKey,
    environmentKey,
    params,
  }: {
    projectKey: string;
    environmentKey: string;
    params?: GetAllHoldoutsQueryParams;
  }) => ({
    queryKey: params ? [projectKey, environmentKey, params] : [projectKey, environmentKey],
    queryFn: async ({ signal }) =>
      reactQueryResponseAdapter(getAllHoldouts({ projectKey, environmentKey, query: params }, { signal })),
  }),
  detail: ({
    projectKey,
    environmentKey,
    holdoutKey,
    params,
  }: {
    projectKey: string;
    environmentKey: string;
    holdoutKey: string;
    params?: GetHoldoutQueryParams;
  }) => ({
    queryKey: [projectKey, environmentKey, holdoutKey, params],
    queryFn: async () =>
      reactQueryResponseAdapter(getHoldout({ projectKey, environmentKey, holdoutKey, query: params })),
  }),
  detailById: ({
    projectKey,
    environmentKey,
    holdoutId,
  }: {
    projectKey: string;
    environmentKey: string;
    holdoutId: string;
  }) => ({
    queryKey: [projectKey, environmentKey, holdoutId],
    queryFn: async ({ signal }) =>
      reactQueryResponseAdapter(getHoldoutById({ projectKey, environmentKey, holdoutId }, { signal })),
  }),
});

export const holdoutsList = holdouts.list;
export const holdoutsListRoot = holdouts.list._def;
export const holdoutsDetailRoot = holdouts.detail._def;
export const holdoutsDetail = holdouts.detail;
